import * as React from "react";
import type { SVGProps } from "react";

export const DocumentUploadIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    viewBox="0 0 32 32"
    {...props}>
    <path
      fill={props.fill || "#1558FF"}
      d="M16 3.2v7.2a2.4 2.4 0 0 0 2.4 2.4h7.2v13.6a2.4 2.4 0 0 1-2.4 2.4h-7.612A8.8 8.8 0 0 0 6.4 14.731V5.6a2.4 2.4 0 0 1 2.4-2.4H16Zm1.6.4v6.8a.8.8 0 0 0 .8.8h6.8l-7.6-7.6ZM8.8 30.4a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4Zm3.765-7.766a.8.8 0 1 1-1.131 1.132L9.6 21.93V26.4a.8.8 0 1 1-1.6 0v-4.469l-1.835 1.835a.8.8 0 0 1-1.131-1.132l3.2-3.2a.799.799 0 0 1 .56-.234h.01a.798.798 0 0 1 .558.231l.004.004 3.2 3.2Z"
    />
  </svg>
);
